import React from 'react'
import { useTranslation } from 'i18n'
import {
  BodyCopy,
  Button,
  EmbedCode,
  Image,
  ImageComparison,
  OldBodyCopy,
} from './ListicleContents'
import { DropdownButton } from './components/DropdownButton'
import { legacyImageURL } from 'components/LegacyImage'
import analytics from 'global/AnalyticsData'

export const LISTICLE_CONTENTS = {
  BodyCopy: (step, item, content) => (
    <BodyCopy bodyCopy={content.bodyCopy} order={content.displayOrder} />
  ),
  Button: (step, item, content) => (
    <Button
      url={content.url}
      bgColor={content.bgColor}
      buttonText={content.buttonText}
      order={content.displayOrder}
      onClick={() => {
        analytics.stepEvent('step_interaction_listicle_button_click', step, {
          result_id: content.id,
          result: content.buttonText + ' | ' + content.url,
        })
      }}
    />
  ),
  EmbedCode: (step, item, content) => (
    <EmbedCode embedCode={content.embedCode} order={content.displayOrder} />
  ),
  Image: (step, item, content) => (
    <Image image={content.image} order={content.displayOrder} />
  ),
  ImageComparison: (step, item, content) => (
    <ImageComparison
      leftImageUrl={legacyImageURL(content.leftImage)}
      rightImageUrl={legacyImageURL(content.rightImage)}
      order={content.displayOrder}
    />
  ),
  Menu: (step, item, content) => (
    <DropdownButton
      text={content.text}
      items={content.items}
      order={content.displayOrder}
      onClick={(buttonText, url) => {
        analytics.stepEvent('step_interaction_listicle_button_click', step, {
          result_id: content.id,
          result: buttonText + ' | ' + url,
        })
      }}
    />
  ),
  OldBodyCopy: (step, item, content) => (
    <OldBodyCopy content={content.content} order={content.displayOrder} />
  ),
  Subhead: (step, item, content) => (
    <h2
      className="content-item subhead"
      style={{ order: content.displayOrder }}
    >
      {content.subHead}
    </h2>
  ),
}

export const ListicleContent = ({ step, item, content }) => {
  const { t } = useTranslation('listicle')
  const contentComponent = LISTICLE_CONTENTS[content?.type]
  return contentComponent ? (
    contentComponent(step, item, content)
  ) : (
    <p>{t('unhandledContent')}</p>
  )
}
